import React from "react";
import * as StyleDOM from "../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateDocuments.jsx";
import calendarIcon from "../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../Assets/Images/calendar-dark-Icon.png";
import ContentDialog from "../Content-Dialog/ContentDialog";
import DatePicker from "../Date-Picker/DatePicker";
import CustomTimePicker from "../Time-Picker/TimePicker";
import DynamicSelectInput from "../Select-Input/SelectInput";
import Button from "../Button/Button.js";

function DynamicReminder({
  isOpen,
  onClose,
  onSubmit,
  reminderFormik,
  callbackReminderOffset,
  isDarkMode,
  isEditMode,
  handleDeleteCallbackRemainder,
}) {
  return (
    <ContentDialog
      isOpen={isOpen}
      title={isEditMode ? "Update Callback Reminder" : "Set Callback Reminder"}
      onClose={onClose}
      onCloseIconClose={onClose}
      submitButtonLabel={isEditMode ? "Update Reminder" : "Set Reminder"}
      cancelButtonLabel="Cancel"
      event={onSubmit}
      contentWidth="40vw"
      contentHeight="auto"
      extraButton={
        isEditMode ? (
          <Button
            label="Delete"
            event={handleDeleteCallbackRemainder}
            backgroundColor="red"
            style={{ marginLeft: "25px" }}
            hoverd={false}
          />
        ) : null
      }
      overflowY
    >
      <StyleDOM.StyledRemainderContainer style={{ padding: "20px" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <StyleDOM.TrackingHeader style={{ marginTop: 0 }}>
            Callback Date <span style={{ color: "red" }}>*</span>
          </StyleDOM.TrackingHeader>
          <DatePicker
            selectedDate={reminderFormik.values.callbackAt}
            onDateChange={(date) =>
              reminderFormik.setFieldValue("callbackAt", date)
            }
            placeholder="Select callback date"
            minDate={new Date()}
            enableArrows={false}
            width="96%"
            icon={isDarkMode ? darkCalendarIcon : calendarIcon}
          />
        </div>
        <div>
          <StyleDOM.TrackingHeader style={{ marginTop: 0 }}>
            Callback Time <span style={{ color: "red" }}>*</span>
          </StyleDOM.TrackingHeader>
          <CustomTimePicker
            selectedTime={reminderFormik.values.callbackTime}
            onChange={(time) =>
              reminderFormik.setFieldValue("callbackTime", time)
            }
            placeholderText="Select callback time"
          />
        </div>
        <div>
          <StyleDOM.TrackingHeader style={{ marginTop: 0 }}>
            Notify Before
            <span style={{ color: "red" }}>*</span>
          </StyleDOM.TrackingHeader>
          <DynamicSelectInput
            placeholder="Select reminder offset"
            options={callbackReminderOffset}
            value={reminderFormik.values.callbackOffset}
            onChange={(e) =>
              reminderFormik.setFieldValue("callbackOffset", e.target.value)
            }
            menuProps={{
              style: { zIndex: 9999 },
            }}
            sx={{
              mt: "5px",
              "& .MuiSelect-select": {
                padding: "13px !important",
              },
            }}
          />
        </div>
      </StyleDOM.StyledRemainderContainer>
    </ContentDialog>
  );
}

export default DynamicReminder;
